export const TRANSACTION_STATUS_FAILED = 0;
export const TRANSACTION_STATUS_SUCCESS = 1;
export const TRANSACTION_STATUS_PENDING = 2;